import { ProductFlow, BoxState, BundleState, ColumnType, ContainerType } from 'data/__generated__';

export const BUNDLE_TYPES_LABELS = {
    dry: 'Sec',
    fresh: 'Frais',
    bakery: 'Boulang',
    kumo: 'Kumo',
    fruit: 'Fruit',
    caterer: 'Traiteur',
};

export type BoxProductFormData = {
    _id: string; // not editable
    photoUrl?: string | null;
    location?: string | null;
    productLabel: string;
    quantity: number;
    quantityPicked: number | null;
    unitPrice: number | null;
    unitVolume?: number | null;
    unitWeight?: number | null;
};

export type BoxFormData = {
    _id: string; // not editable
    code?: string | null;
    deliveryCode: string; // not editable
    type: ProductFlow; // not editable
    containerType: ContainerType; // not editable
    products: BoxProductFormData[];
    createdAt: number; // not editable
    bundleId?: string | null; // staged to null by the "Retirer du bundle" button
    state: BoxState; // staged to Aborted by the "Retirer de la livraison" button
    bundle?: {
        _id: string;
        number: number;
        state: BundleState;
        closingDate?: number | null;
    } | null;
    label: string; // not editable
    number: number; // not editable
    volumeTaken?: number | null; // not editable
    weightTaken?: number | null; // not editable
    position?: number | null; // not editable
    sequence?: number | null; // not editable
    columnId?: string | null; // not editable
    column?: {
        name: string;
        fullname: string;
        type: ColumnType;
    } | null; // not editable
};

export type BundleFormData = {
    _id: string; // not editable
    state: BundleState;
    boxes: BoxFormData[];
};

export type ModifiedProduct = {
    boxId: string;
    productId: string;
    quantity: number;
    quantityPicked: number | null;
};

export type PendingProduct = {
    product: {
        _id: string;
        productLabel: string;
        photoUrl: string;
        location?: string;
        unit?: string;
    };
    boxId: string;
    quantity: number;
    quantityPicked: number | null;
};
